/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Save_Changes_ButtonInputs */

const en_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const fr_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications`)
};

const de_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const it_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva modifiche`)
};

const ru_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить изменения`)
};

const es_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const zh_cn2_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存更改`)
};

const ja_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を保存`)
};

const hi_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सुरक्षित करें`)
};

const pt_pt2_tags_manager_save_changes_button = /** @type {(inputs: Tags_Manager_Save_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Tags_Manager_Save_Changes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_save_changes_button = /** @type {((inputs?: Tags_Manager_Save_Changes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Save_Changes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_save_changes_button(inputs)
	if (locale === "de") return de_tags_manager_save_changes_button(inputs)
	if (locale === "it") return it_tags_manager_save_changes_button(inputs)
	if (locale === "ru") return ru_tags_manager_save_changes_button(inputs)
	if (locale === "es") return es_tags_manager_save_changes_button(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_save_changes_button(inputs)
	if (locale === "ja") return ja_tags_manager_save_changes_button(inputs)
	if (locale === "hi") return hi_tags_manager_save_changes_button(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_save_changes_button(inputs)
	return en_tags_manager_save_changes_button(inputs)
});